import { AuthHttpClient } from "../services/AuthHttpClient";

export const getInvoices = () => {
    return AuthHttpClient( MEMBERS_API_URL + '/api/v1/private/payment/invoices', {
        method: 'GET'
    })
};
